import AmountConfig from '@/models/dackpartner/AmountConfig'
import PercentageConfig from '@/models/dackpartner/PercentageConfig'

export default class SupplierConfig {
  public supplierId: number
  public brandId: number
  public discountPercent: number
  public amountConfig: AmountConfig
  public percentageConfig: PercentageConfig

  public constructor(data: Record<string, unknown> = null) {
    if (!data) {
      data = {}
    }
    this.supplierId = data.supplierId ? (data.supplierId as number) : null
    this.brandId = data.brandId ? (data.brandId as number) : null
    this.discountPercent = data.discountPercent ? (data.discountPercent as number) : 0

    this.amountConfig = new AmountConfig(data.amountConfig as Record<string, unknown>)
    this.percentageConfig = new PercentageConfig(data.percentageConfig as Record<string, unknown>)
  }

  public clone(): SupplierConfig {
    const result = new SupplierConfig()
    Object.assign(result, this)
    return result
  }
}
